let moment = require('moment');
let helperMethods = require('../helperMethods.js');

require('../PersonNameValidator');

let validDateType = (day, month, year) => helperMethods.isInteger(day) && helperMethods.isInteger(month) && helperMethods.isInteger(year);
let invalidDateValues = (day, month, year) => day < 1 || day > 31 || month < 1 || month > 12 || year.length !== 4;
let dateIsInPast = (date) => moment(date).isSameOrBefore(helperMethods.today());

let isTransactionDateValid = (date) => {
    let oldestValidDate = moment(helperMethods.today()).subtract(13, 'days');
    return moment(date).isBetween(oldestValidDate, helperMethods.today(), 'day', '[]');
};

let fullYearDateValidator = (dayClass, monthClass, yearClass) => {
    return () => {
        let day = helperMethods.zeroPad($(dayClass).val().trim(), 2);
        let month = helperMethods.zeroPad($(monthClass).val().trim(), 2);
        let year = $(yearClass).val().trim();

        return dateValidator(day, month, year);
    };
};

let abbreveatedYearDateValidator = (dayClass, monthClass, yearClass) => {
    return () => {
        let day = helperMethods.zeroPad($(dayClass).val().trim(), 2);
        let month = helperMethods.zeroPad($(monthClass).val().trim(), 2);
        let year = helperMethods.twentyPrepend($(yearClass).val().trim());

        return dateValidator(day, month, year);
    };
};

let dateValidator = (day, month, year) => {
    let dateInput = moment([year, month, day].join('-'), 'YYYY-MM-DD');

    helperMethods.removeErrorMessages();

    if (!validDateType(day, month, year)) {
        helperMethods.addErrorMessages();
        return false;
    }

    if (invalidDateValues(day, month, year)) {
        helperMethods.addErrorMessages();
        return false;
    }

    if (dateInput.isValid()) {
        return true;
    }

    helperMethods.addErrorMessages();
    return false;
}

let membershipCardNumberValidator = (membershipCardNumberClass) => {
    return () => /^\d{18}$/.test(helperMethods.stripSpaces('' + $(membershipCardNumberClass).val()));
};

window.Parsley
    .addValidator('password', {
        requirementType: 'string',
        validateString: (value) => {
            let passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,99}$/;
            return (passwordRegex.test(value));
        }
    })
    .addMessage('en', 'password', 'Choose a different password - it must be at least 8 characters, and including a mix of numbers and upper and lower case letters')
    .addValidator('transactiondate', {
        priority: 50,
        requirementType: 'string',
        validateString: () => {
            let day = helperMethods.zeroPad($('.date-day').val().trim(), 2);
            let month = helperMethods.zeroPad($('.date-month').val().trim(), 2);
            let year = helperMethods.twentyPrepend($('.date-year').val().trim());
            let date = moment([year, month, day].join('-'), 'YYYY-MM-DD');

            return isTransactionDateValid(date);
        }
    })
    .addMessage('en', 'transactiondate', 'Check your transaction date, you must add receipts within 14 days.')
    .addValidator('age', {
        requirementType: 'string',
        validateString: () => {
            let day = helperMethods.zeroPad($('#member-day-of-birth').val().trim(), 2);
            let month = helperMethods.zeroPad($('#member-month-of-birth').val().trim(), 2);
            let year = $('#member-year-of-birth').val().trim();
            let dateInput = moment(year + '-' + month + '-' + day, 'YYYY-MM-DD');

            let sixteenYearsAgo = moment().subtract(16, 'years').startOf('day');
            let dateOfBirth = moment(dateInput).startOf('day');

            let isOlderThan16 = moment(dateOfBirth).isBefore(moment(sixteenYearsAgo));
            let isExactly16 = moment(dateOfBirth).isSame(moment(sixteenYearsAgo));

            helperMethods.removeErrorMessages();

            if (isOlderThan16 || isExactly16) {
                return true;
            }

            helperMethods.addErrorMessages();
            return false;
        },
        priority: 65
    })
    .addMessage('en', 'age', 'Error, if you are under 16 please call 0800 023 4708 to join')
    .addValidator('date', {
        requirementType: 'string',
        validateString: fullYearDateValidator('.date-day', '.date-month', '.date-year'),
        priority: 66
    })
    .addMessage('en', 'date', 'Error, enter a valid date (DD/MM/YYYY).')
    .addValidator('expiryrequired', {
        requirementType: 'string',
        validateString: () => $('#card-month').val() !== '',
        priority: 68
    })
    .addMessage('en', 'expiryrequired', 'Error, enter the card expiry date (MM/YY).')
    .addValidator('expiry', {
        requirementType: 'string',
        validateString: () => {
            let month = $('#card-month').val();
            let year = $('#card-year').val();
            let dateInput = moment('01-' + helperMethods.zeroPad(month, 2) + '-' + helperMethods.zeroPad(year, 2), 'DD-MM-YYYY');
            let currentDate = moment().startOf('month');

            return !!(currentDate.isSame(dateInput) || currentDate.isBefore(dateInput));
        },
        priority: 67
    })
    .addMessage('en', 'expiry', 'Expiry date cannot be in the past.')
    .addValidator('dateofbirth', {
        requirementType: 'string',
        validateString: fullYearDateValidator('.date-day', '.date-month', '.date-year'),
        priority: 69
    })
    .addMessage('en', 'dateofbirth', 'Enter your full date of birth.')
    .addValidator('dateofbirthnew', {
        requirementType: 'string',
        validateString: fullYearDateValidator('.date-day', '.date-month', '.date-year'),
        priority: 69
    })
    .addMessage('en', 'dateofbirthnew', 'Enter your full date of birth.')
    .addValidator('membershipcardnumber', {
        requirementType: 'string',
        validateString: membershipCardNumberValidator('.membership-number'),
        priority: 71
    })
    .addMessage('en', 'membershipcardnumber', 'Check you\'ve given the correct membership number - it\'s the 18-digit number on the back of your card.')
    .addValidator('registercheckcard', {
        requirementType: 'string',
        validateString: (value) => {
            if (value === null) {
                return false;
            }

            let trimmed = value.replace(/\s*/g,'');
            return /^633174\d{12}$/.test(trimmed);
        },
        priority: 1
    })
    .addMessage('en', 'registercheckcard', 'Check you\'ve given the correct membership number - it\'s the 18-digit number on the back of your card.')
    .addValidator('membershipcardnumbersearch', {
        requirementType: 'string',
        validateString: membershipCardNumberValidator('.membership-number-search'),
        priority: 73
    })
    .addMessage('en', 'membershipcardnumbersearch', 'Error, enter a valid membership card number.')
    .addValidator('dateddmmyy', {
        requirementType: 'string',
        validateString: abbreveatedYearDateValidator('.date-day', '.date-month', '.date-year'),
        priority: 74
    }).addMessage('en', 'dateddmmyy', 'Enter a valid transaction date.');

module.exports = {
    isTransactionDateValid: isTransactionDateValid,
    dateIsInPast: dateIsInPast
};
